export default __webpack_public_path__ + "4c1898b4ddba48b102198f6a68ba0312.png";